"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectCardPopover = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const material_1 = require("@mui/material");
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const SubjectAvatar_1 = require("../SubjectAvatar");
const SubjectCard_1 = require("../SubjectCard");
/**
 *
 * A component wrapping SubjectCard and SubjectAvatar to easily display an Avatar with a popover on click given a subject.
 * The top level props are spread on to the SubjectCard component.
 *
 * @example ### Basic example
 *
 * This examples shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_SubjectPopover.jsx
 * ```
 * @category component
 */
const SubjectCardPopover = ({ subject, popoverProps, subjectAvatarProps, subjectAvatarIconButtonProps, ...rest }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Popover_1.default, { open: Boolean(anchorEl), transformOrigin: {
                horizontal: "left",
                vertical: "top",
            }, anchorOrigin: {
                horizontal: "left",
                vertical: "bottom",
            }, anchorEl: anchorEl, onClose: handlePopoverClose, ...popoverProps },
            react_1.default.createElement(SubjectCard_1.SubjectCard, { subject: subject, ...rest })),
        react_1.default.createElement(material_1.IconButton, { onClick: handlePopoverOpen, ...subjectAvatarIconButtonProps },
            react_1.default.createElement(SubjectAvatar_1.SubjectAvatar, { subject: subject, ...subjectAvatarProps }))));
};
exports.SubjectCardPopover = SubjectCardPopover;
